
const ALLOWED_PHONE_PATTERN = /^\+?[0-9()\-\s]+$/;

export const normalizeOptionalPhone = (phone) => {
  const normalizedPhone = (phone || '').trim();
  return normalizedPhone || '';
};

export const isValidOptionalPhone = (phone) => {
  const normalizedPhone = normalizeOptionalPhone(phone);
  if (!normalizedPhone) {
    return true;
  }

  if (!ALLOWED_PHONE_PATTERN.test(normalizedPhone)) {
    return false;
  }

  const plusMatches = normalizedPhone.match(/\+/g) || [];
  if (plusMatches.length > 1 || (normalizedPhone.includes('+') && !normalizedPhone.startsWith('+'))) {
    return false;
  }

  const openParens = normalizedPhone.match(/\(/g) || [];
  const closeParens = normalizedPhone.match(/\)/g) || [];
  if (openParens.length !== closeParens.length) {
    return false;
  }

  const digitCount = (normalizedPhone.match(/\d/g) || []).length;
  return digitCount >= 7 && digitCount <= 15;
};
